<script>
  let { preset = $bindable('final'), imagesPerModel = $bindable(4), readonly = false } = $props();
  function choose(value) {
    preset = value;
    imagesPerModel = value === 'draft' ? 1 : 4;
  }
</script>

<div class="preset-control" role="group" aria-label="Render preset">
  <button type="button" class:active={preset === 'draft' && Number(imagesPerModel) === 1} aria-pressed={preset === 'draft' && Number(imagesPerModel) === 1} disabled={readonly} onclick={() => choose('draft')}>
    <strong>Draft</strong><span>1 image · fewer steps</span>
  </button>
  <button type="button" class:active={preset === 'final' && Number(imagesPerModel) === 4} aria-pressed={preset === 'final' && Number(imagesPerModel) === 4} disabled={readonly} onclick={() => choose('final')}>
    <strong>Final</strong><span>4 images · recommended steps</span>
  </button>
</div>
<p class="preset-note">Per model and prompt. Image size and custom model settings stay as selected.</p>

<style>
  .preset-control { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 0.5rem; }
  button { min-height: 64px; padding: 0.6rem; background: var(--color-surface); border: 1px solid var(--color-border); color: var(--color-text); border-radius: 10px; cursor: pointer; text-align: left; }
  button.active { border-color: var(--color-primary); background: var(--color-primary-light, #ffeff7); }
  button:disabled { opacity: 0.5; cursor: default; }
  button:focus-visible { outline: 2px solid var(--color-primary); outline-offset: 2px; }
  strong, span { display: block; }
  strong { font-size: 0.85rem; }
  span { margin-top: 0.2rem; font-size: 0.7rem; color: var(--color-text-muted); }
  .preset-note { margin: 0.35rem 0 0; font-size: 0.75rem; color: var(--color-text-muted); line-height: 1.5; }
</style>
